import { createSlice } from "@reduxjs/toolkit";
import { confirmAnomaly, getAnomalyTable, updateAnomaly, getAnomalyForPerformerUser } from "./anomalyApi";
import { toast } from "react-toastify";
import { getAnomalyChart } from "../anomalyReport/anomalyChartApi";


export const anomalySlice = createSlice({
    name: 'anomaly',
    initialState: {
        tag: "",
        username: "",
        description: "",
        currentMachine: "",
        currentArea: "",
        currentLine: "",
        isNew: true,
        problemPhotoBase64: "",
        problemVideo: null,
        chartData: null,
        table: null,
    },
    reducers: {
        resetAnomalyTag: (state) => {
            state.tag = ""
        },
        resetAnomalyDescription: (state) => {
            state.description = ""
        },
        setAnomalyTag: (state, action) => {
            state.tag = action.payload
        },
        setAnomalyDescription: (state, action) => {
            state.description = action.payload
        },
        resetAnomaly: (state) => {
            state.security = false
            state.minor = false
            state.basicCondition = false
            state.quality = false
            state.pollution = false
            state.hardToReach = false
            state.username = ""
            state.description = ""
            state.currentMachine = ""
            state.currentArea = ""
            state.currentLine = ""
            state.table = null
            state.chartData = null
            state.problemPhotoBase64 = ""
            state.problemVideo = null
        },

        setAnomalyEditor: (state, action) => {
            state.username = action.payload["username"]
            state.isNew = false
            state.currentMachine = action.payload["equipment_name"]
            state.description = action.payload["description"]
        },
        setProblemPhotoBase64: (state, action) => {
            state.problemPhotoBase64 = action.payload
        },
        setProblemVideo: (state, action) => {
            state.problemVideo = action.payload
        },
        resetProblemPhotoBase64: (state) => {
            state.problemPhotoBase64 = ""
        },
        resetAnomalyChartData: (state) => {
            state.chartData = null
        },
        resetAnomalyTable: (state) => {
            state.table = null
        }


    },
    extraReducers: (builder) => {
        builder.addCase(confirmAnomaly.fulfilled, (state, action) => {

            state.isActivate = true;
            state.username = action.meta.arg.username
            state.token = action.payload.auth_token
            state.navigation = "CONTROL"
            state.status = "SUCCESS"
            console.log('SUCCESS')
            toast.success('Аномалия зарегистрирована!', {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });

            //let navigate = useNavigate();
            //navigate("/control", { replace: true });
        })
        builder.addCase(confirmAnomaly.pending, (state, action) => {
            state.status = 'LOGIN'

        })

        builder.addCase(confirmAnomaly.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 401"){
                localStorage.clear()
                message = "Нужно авторизоваться!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        })

        builder.addCase(updateAnomaly.fulfilled, (state, action) => {

            state.isActivate = true;
            state.username = action.meta.arg.username
            state.token = action.payload.auth_token
            state.navigation = "CONTROL"
            state.status = "SUCCESS"
            console.log('SUCCESS')
            toast.success('Данные по аномалии обновлены!', {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            //let navigate = useNavigate();
            //navigate("/control", { replace: true });
        })
        builder.addCase(updateAnomaly.pending, (state, action) => {
            state.status = 'LOGIN'

        })

        builder.addCase(updateAnomaly.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 401"){
                localStorage.clear()
                message = "Нужно авторизоваться!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        })


        builder.addCase(getAnomalyChart.fulfilled, (state, action) => {
            state.chartData = action.payload
        })
        builder.addCase(getAnomalyChart.pending, (state, action) => {
        })

        builder.addCase(getAnomalyChart.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 401"){
                localStorage.clear()
                message = "Нужно авторизоваться!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });

        })

        builder.addCase(getAnomalyTable.fulfilled, (state, action) => {
            state.table = action.payload["result"]
        })
        builder.addCase(getAnomalyTable.pending, (state, action) => {
        })

        builder.addCase(getAnomalyTable.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 401"){
                localStorage.clear()
                message = "Нужно авторизоваться!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });

        })

    }
})


export const { setProblemVideo, setAnomalyEditor, setProblemPhotoBase64, resetProblemPhotoBase64, setAnomalyTag, setAnomalyDescription, resetAnomalyTag, resetAnomalyDescription, resetAnomalyChartData, resetAnomalyTable, resetAnomaly } = anomalySlice.actions

export default anomalySlice.reducer
